var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content != null)?_c('div',{staticClass:"wysiwyg",class:_vm.bg,domProps:{"innerHTML":_vm._s(_vm.content)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }